import { useEffect, useRef } from "react";
import { supabase } from "./supabaseClient";

type EventType = "INSERT" | "UPDATE" | "DELETE";

export function useRealtimeChannel({
  tripId,
  table,
  onEvent,
}: {
  tripId: string;
  table: string;
  onEvent: (params: {
    table: string;
    event: EventType;
    newData: any;
    oldData: any;
  }) => void;
}): () => void {
  const unsubscribeRef = useRef<() => void>(() => {});

  useEffect(() => {
    if (!tripId || !table) return;

    // 🆕: individueller Channel pro Tabelle + Trip
    const channelName = `trip:${tripId}:${table}`;

    const channel = supabase
      .channel(channelName)
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table,
        },
        (payload) => {
          const eventType = payload.eventType as EventType;
          const tableName = payload.table;

          onEvent({
            table: tableName,
            event: eventType,
            newData: payload.new,
            oldData: payload.old,
          });
        }
      )
      .subscribe();

    unsubscribeRef.current = () => {
      supabase.removeChannel(channel);
    };

    return () => {
      supabase.removeChannel(channel);
    };
  }, [tripId, table, onEvent]);

  return () => {
    unsubscribeRef.current();
  };
}
